import { render, staticRenderFns } from "./PopUpMapGeoNovation.vue?vue&type=template&id=c052549a&"
import script from "./PopUpMapGeoNovation.vue?vue&type=script&lang=js&"
export * from "./PopUpMapGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports